import React from "react";
import { useFormik, FormikProvider, Form, useField } from "formik";
import * as Yup from "yup";
import PropType from "prop-types";
import "./ForgotPassword.css";

export const TextInputLiveFeedback = ({ label, helpText, ...props }) => {
  const [field, meta] = useField(props);

  // Show inline feedback if EITHER
  // - the input is focused AND value is longer than 2 characters
  // - or, the has been visited (touched === true)
  const [didFocus, setDidFocus] = React.useState(false);
  const handleFocus = () => setDidFocus(true);
  const showFeedback =
    (!!didFocus && field.value.trim().length > 2) || meta.touched;

  return (
    <div
      className={`form-control ${
        showFeedback ? (meta.error ? "form-invalid" : "form-valid") : ""
      }`}
    >
      <div className="flex items-center space-between">
        <label htmlFor={props.id} className="form-label">
          {label}
        </label>{" "}
        {showFeedback ? (
          <div
            id={`${props.id}-feedback`}
            aria-live="polite"
            className="form-feedback text-sm"
          >
            {meta.error ? meta.error : "✓"}
          </div>
        ) : null}
      </div>
      <input
        className="form-input"
        {...props}
        {...field}
        aria-describedby={`${props.id}-feedback ${props.id}-help`}
        onFocus={handleFocus}
      />
      <div className="text-xs" id={`${props.id}-help`} tabIndex="-1">
        {helpText}
      </div>
    </div>
  );
};

TextInputLiveFeedback.propTypes = {
  id: PropType.number.isRequired,
  label: PropType.string.isRequired,
  helpText: PropType.string.isRequired,
};

export default function ForgotPasswordForm(props) {
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: async (values) => {
      await sleep(500);

      props.onSubmit(values.email);
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .email("Please enter a valid email")
        .required("Required"),
    }),
  });

  return (
    <FormikProvider value={formik}>
      <Form>
        <TextInputLiveFeedback
          label="Email Address"
          id="forgot-password-email"
          name="email"
          helpText="Enter the email associated with your Gup's Corner account."
          type="email"
        />
        <div>
          <button className="form-submit" type="submit">
            Submit
          </button>
        </div>
      </Form>
    </FormikProvider>
  );
}

ForgotPasswordForm.propTypes = {
  onSubmit: PropType.func.isRequired,
};
